import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Spinner } from "reactstrap";
import { useAuth } from "context/AuthContext";


function ReceiveSession() {
    const navigate = useNavigate();
    const location = useLocation();
    const { login, logout } = useAuth();

    useEffect(() => {
        const params = new URLSearchParams(location.search);

        const accessToken = params.get('access_token');
        const refreshToken = params.get('refresh_token');
        const companyProfile = JSON.parse(params.get('company_profile'));
        const userProfile = JSON.parse(params.get('user_profile'));
        
        if( !accessToken ){
            // Redirect to dashboard
            navigate('/dashboard');
            return;
        }
        logout();
        
        login( {
            tokens: {
                access: {token: accessToken},
                refresh: {token: refreshToken}
            },
            companyProfile,
            user: userProfile,
        }, true );

        // Redirect to dashboard
        navigate('/dashboard');
    }, [location.search, navigate, login, logout]);

    return (
        <div style={{ padding: "20px", textAlign: "center" }}>
            <h3>Processing Session...</h3>
            <p>Redirecting to dashboard...</p>
            <Spinner>
                Loading...
            </Spinner>
        </div>
    );
}

export default ReceiveSession;
